import { render } from "./Demonstration.vue?vue&type=template&id=5b3633aa&ts=true"
import script from "./Demonstration.vue?vue&type=script&lang=ts"
export * from "./Demonstration.vue?vue&type=script&lang=ts"

import "./Demonstration.vue?vue&type=style&index=0&id=5b3633aa&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__